import { performSearch } from "./search-hub";

export function setClearFilters(filtersCheckboxes, clearAllButton, formControl, currentAbortController) {
    if (clearAllButton) {
        clearAllButton.addEventListener("click", (e) => {
            e.preventDefault()
            filtersCheckboxes.forEach((el) => {
                el.checked = false
            })

            if (formControl) {
                performSearch(1, formControl, currentAbortController);
            }
        })
    }
}

export function setEventFilterCheckBox(checkboxes, formControl, currentAbortController) {
    if (checkboxes) {
        checkboxes.forEach((el) => {
            el.addEventListener("input", (e) => {
                filterActions(e, el, formControl, currentAbortController);
            });
        })
    }
}

export function setEventInsideResponseFilter(tags, formControl, currentAbortController) {
    if ([...tags].length > 0) {
        [...tags].forEach(tag => {
            tag.addEventListener("click", (e)=>{
                e.preventDefault();

                const tagValueFilter = tag.dataset.tagValue;

                const matchingElements = document.querySelectorAll(
                    `input[id="org-${tagValueFilter}"], input[data-id="tags-${tagValueFilter}"]`
                )

                matchingElements.forEach((matchEl) => {
                    matchEl.checked = true;
                });

                if (formControl) {
                    performSearch(1, formControl, currentAbortController, tagValueFilter);
                }
            });
        });
    }
}

export function setOrderEvent(filterOrder, formControl, currentAbortController) {
    if (filterOrder) {
        filterOrder.addEventListener("input", (e) => {
            e.preventDefault()

            if (formControl) {
                performSearch(1, formControl, currentAbortController);
            }
        })
    }
}

function filterActions(event, element, formControl, currentAbortController) {
    event.preventDefault()

    const value = element.id
    const newValue = value.replace("-select", "");
    const popularValue = value.replace("-select", "-popular");

    const matchingElements = document.querySelectorAll(
        `input[id="${newValue}"], input[id="${popularValue}"]`
    );

    matchingElements.forEach((matchEl) => {
        if (matchEl !== element) {
            matchEl.checked = false;
        }

        if (element.checked) {
            matchEl.checked = true;
        }
    });

    if (formControl) {
        performSearch(1, formControl, currentAbortController);
    }
}